import message from '../messages/Message';

export const CurrentPricesRoute = "/";
export const FuturePricesRoute = message('url_future_prices')
export const SubFutureCategory = `${FuturePricesRoute}${message('url_future_url_subcategory')}`;
export const SubCategory = CurrentPricesRoute + message('url_subcategory');

